import { StyleSheet } from 'react-native'

export const useStyles = (theme) => StyleSheet.create({
  main: { width: '100%', flexDirection: 'row', paddingTop: 20, paddingBottom: 20, position: 'absolute', backgroundColor: theme.WHITE, alignItems: 'center' },
  buttonContainer: { marginLeft: 'auto', justifyContent: 'center', marginRight: 10 },
  button: { paddingLeft: 5, paddingRight: 5, height: 30 },
  exitContainer: {
    alignItems: 'center'
  },
  imageContainer: {
    marginRight: 10,
    marginLeft: 0,
    width: 100,
    height: 100
  },
  text: {
    marginTop: 3,
    marginBottom: 3
  }
})
